export const COUNTRY_CODE = {
  USA: 'US',
  Canada: 'CA',
};

export const COUNTRY_NAME = {
  US: 'USA',
  CA: 'Canada',
};
